import {
  FETCH_COMPANIES_PAGE_CONTENT,
  FETCH_COMPANIES_PAGE_CONTENT_SUCCESS,
  FETCH_COMPANIES_PAGE_CONTENT_FAILED,
  FETCH_COMPANIES_SEARCH_DATA,
  FETCH_COMPANIES_SEARCH_DATA_SUCCESS,
  FETCH_COMPANIES_SEARCH_DATA_FAILED,
  FETCH_COMPANY_DETAIL,
  FETCH_COMPANY_DETAIL_SUCCESS,
  FETCH_COMPANY_DETAIL_FAILED,
} from "../actions/actionTypes";

const initialState = {
  isLoading: true,
  isSearching: false,
  content: {},
  companies: [],
  featured_companies: [],
  totalCompanies: 0,
  // Only set when the page is filtered by occupation (?soc=).
  occupationName: "",
  sponsorFeatured: [],
  error: false,
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_COMPANIES_PAGE_CONTENT:
      return {
        ...state,
        isLoading: true,
        content: {},
        featured_companies: [],
      };
    case FETCH_COMPANIES_PAGE_CONTENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        content: payload,
        featured_companies: payload.featured_companies,
      };
    case FETCH_COMPANIES_PAGE_CONTENT_FAILED:
      return {
        ...state,
        isLoading: false,
        content: {},
        featured_companies: [],
        error: payload,
      };
    case FETCH_COMPANIES_SEARCH_DATA:
      return {
        ...state,
        isSearching: true,
      };
    case FETCH_COMPANIES_SEARCH_DATA_SUCCESS:
      return {
        ...state,
        isSearching: false,
        companies: payload.companies,
        totalCompanies: payload.totalCompanies,
        occupationName: payload.occupationName || "",
        sponsorFeatured: payload.sponsorFeatured || [],
        isLoading: false,
      };
    case FETCH_COMPANIES_SEARCH_DATA_FAILED:
      return {
        ...state,
        isSearching: false,
        error: payload,
      };
    case FETCH_COMPANY_DETAIL:
      return {
        ...state,
        isLoading: true,
        content: {},
        // events: [],
      };
    case FETCH_COMPANY_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        content: payload.data,
        // events: payload.events,
      };
    case FETCH_COMPANY_DETAIL_FAILED:
      return {
        ...state,
        isLoading: false,
        content: {},
        // events: [],
        error: payload,
      };
    default:
      return state;
  }
}
